import React, { PureComponent } from 'react';
import { withPersonState } from 'src/ver2/pages/person/context';
import LittleQuest from 'src/ver2/components/quest/little';
import Loader from 'src/ver2/components/loader';

import './style.css';

class PersonQuestsPlashka extends PureComponent {

    state = {
        listModalData: null,
        lastHeight: -1
    }

    componentDidMount = () => {
        this.timerR = setInterval(() => {
            const comp = document.getElementsByClassName('person_quests_plashka_inner')
            if (comp && comp[0]) {
                this.setComponentSelfHeight({ height: comp[0].clientHeight + 80 })
            }
        }, 500)
    }

    componentWillUnmount() {
        if (this.timerR) {
            clearInterval(this.timerR);
            delete this.timerR;
        }
    }

    setComponentSelfHeight = ({ height }) => {
        const { setComponentSelfHeight, plashkaId } = this.props;

        if (height === this.state.lastHeight) return;
        this.setState({ lastHeight: height })
        setComponentSelfHeight({ plashkaId, height });

    };

    isReleased = () => {
        this.props.reloadScores();
        this.props.reloadServerQuests();
    }

    render() {

        const { isMobile, client, ServerQuests, isServerQuestsReady, iamuser } = this.props;

        const { width, height } = this.props.upperStyle;

        if (!isServerQuestsReady) {
            return <div style={{ width, height }} className='person_quests_plashka'>
            </div>
        }

        let myQuests = [];
        if (iamuser) myQuests = iamuser.myQuests;

        return <div style={{ width, height }} className='person_quests_plashka'>
            <div className='person_quests_plashka_inner'>
                {(ServerQuests || []).map(({ Id }) => <LittleQuest key={`pqp-${Id}`} QuestId={Id} />)}
                {(myQuests || []).map(({ Id }) => <LittleQuest isReleased={this.isReleased} key={`pqp-${Id}`} UserQuestId={Id} />)}
            </div>
        </div>
    }
}

export default withPersonState(
    `
    iamuser,
    client,
    isMobile,
    ServerQuests,
    isServerQuestsReady,

    reloadServerQuests,
    reloadScores
    `
)(PersonQuestsPlashka)